import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable.jsx";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath.jsx";

import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_ATTENDANCE,
  ROLL_CALL_EMP_PROFILE,
  ROLL_CALL_GET_HOLIDAYS,
  ROLL_CALL_GET_PUNCH_TYPE,
  ROLL_CALL_WRITE_SWIPE,
} from "../RollCallConfig/RollCallConfig.js";
import { Spin, Tooltip } from "antd";
import Swal from "sweetalert2";
import CommonFooter from "../../../../core/common/footer/commonFooter.jsx";
import Holidays from "./Holidays.jsx";
import badge from "../RollCallConfig/id-card-svgrepo-com.svg";
import designation from "../RollCallConfig/suitcase-portfolio-svgrepo-com.svg";
import email from "../RollCallConfig/mail-svgrepo-com.svg";

const RollcallDashboard = () => {
  const currentYear = new Date().getFullYear();
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [time, setTime] = useState("");
  const [greeting, setGreeting] = useState("");
  const [profileData, setProfileData] = useState("");
  const [holidays, setHolidays] = useState([]);
  const [nextHoliday, setNextHoliday] = useState(null);
  const [monthlyHolidayCount, setMonthlyHolidayCount] = useState(0);

  const [attendance, setAttendance] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [punchType, setPunchType] = useState("");
  const [loading, setloading] = useState(false);
  const [punchLoading, setPunchLoading] = useState(false);

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;

  const navigate = useNavigate();

  //region greetings
  useEffect(() => {
    const updateTimeAndGreeting = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      // Set time
      const formattedTime = `${String(hours).padStart(
        2,
        "0",
      )}:${minutes}:${seconds}`;
      setTime(formattedTime);

      // Set greeting
      if (hours >= 5 && hours < 12) {
        setGreeting("Good Morning");
      } else if (hours >= 12 && hours < 17) {
        setGreeting("Good Afternoon");
      } else {
        setGreeting("Good Evening");
      }
    };

    updateTimeAndGreeting();
    const intervalId = setInterval(updateTimeAndGreeting, 1000);

    return () => clearInterval(intervalId);
  }, []);

  //region session
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  //region console
  // useEffect(() => {
  //   if (tokenData && superIdData) {
  //     console.log("Token:", tokenData);
  //     console.log("SuperId:", superIdData);
  //   }
  // }, [tokenData, superIdData]);

  //region profile
  useEffect(() => {
    setloading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMP_PROFILE}?regid=${regId}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setProfileData(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setProfileData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  }, [superIdData, tokenData]);

  //region holidays
  useEffect(() => {
    setloading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_HOLIDAYS}?superid=${superIdData}&year=${currentYear}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            const holidays = data.ResultData || [];
            setHolidays(holidays);

            const today = new Date();
            const currentMonth = today.getMonth(); // 0-indexed (0 = January)
            const currentYearLocal = today.getFullYear();

            // Find next upcoming holiday
            const upcoming = holidays
              .map((h) => {
                const dateObj = new Date(h.HolidayDt);
                return {
                  rawDate: dateObj,
                  date: dateObj.toLocaleDateString(undefined, {
                    month: "short",
                    day: "numeric",
                  }),
                  weekday: dateObj.toLocaleDateString(undefined, {
                    weekday: "long",
                  }),
                  isOptional: h.Optional,
                };
              })
              .filter((h) => h.rawDate >= today)
              .sort((a, b) => a.rawDate - b.rawDate)[0];

            setNextHoliday(upcoming || null);

            // Count holidays in current month
            const count = holidays.filter((h) => {
              const date = new Date(h.HolidayDt);
              return (
                date.getMonth() === currentMonth &&
                date.getFullYear() === currentYearLocal
              );
            }).length;

            setMonthlyHolidayCount(count);
          } else {
            console.error("Invalid data format:", data);
            setHolidays([]);
            setNextHoliday(null);
            setMonthlyHolidayCount(0);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setNextHoliday(null);
          setMonthlyHolidayCount(0);
        })
        .finally(() => {
          setloading(false);
        });
    }
  }, [superIdData, tokenData]);

  //region attendance 10days
  const fetchAttendance = () => {
    setloading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_ATTENDANCE}?regid=${regId}&superid=${superIdData}&fromdate=${startDate}&todate=${endDate}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setAttendance(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setAttendance([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  useEffect(() => {
    fetchAttendance();
  }, [superIdData, tokenData]);

  //region start and end date
  useEffect(() => {
    const today = new Date();
    const tenDaysBefore = new Date(today);
    tenDaysBefore.setDate(today.getDate() - 15);

    const formatDate = (date) => {
      return date.toISOString().split("T")[0]; // Formats date as yyyy-mm-dd
    };

    setStartDate(formatDate(tenDaysBefore));
    setEndDate(formatDate(today));
  }, []);

  //region punch type
  const fetchPunchType = () => {
    if (!regId || !tokenData) {
      return;
    }
    setPunchLoading(true);
    fetch(
      `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_PUNCH_TYPE}?regid=${regId}`,
      {
        headers: { Authorization: `Bearer ${tokenData}` },
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.ResultData.length > 0) {
          setPunchType(data.ResultData[0].PunchType);
        } else {
          console.error("Unexpected API response:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching punch type:", error);
      })
      .finally(() => setPunchLoading(false));
  };

  useEffect(() => {
    fetchPunchType();
  }, [regId, tokenData]);

  //region write swipe
  const handlePunch = () => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    if (!userData) {
      console.error("User data is not available in sessionStorage.");
      return;
    }

    const currentDate = new Date();
    const dateOfTransaction = currentDate
      .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata" })
      .replace("T", " ");

    const payload = {
      superid: userData.SuperId,
      regid: userData.RegId,
      cardid: userData.Badge,
      dateoftransaction: dateOfTransaction,
    };

    setPunchLoading(true);

    fetch(`${ROLL_CALL_API_BASE_URL}${ROLL_CALL_WRITE_SWIPE}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenData}`, // Assuming `tokenData` is available
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          Swal.fire({
            title: "Punch Successful!",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              fetchPunchType();
              fetchAttendance();
            }
          });
        } else {
          Swal.fire({
            title: "Punch Failed!",
            text: data.message || "An error occurred.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        console.error("Error in punch action:", error);
        Swal.fire({
          title: "Error!",
          text: "Unable to perform punch action. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      })
      .finally(() => setPunchLoading(false));
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      sorter: (a, b) => a.Date.length - b.Date.length,
    },
    {
      title: "Shift",
      dataIndex: "ActualShift",
      sorter: (a, b) => a.ActualShift?.length - b.ActualShift?.length,
      //   align: "center",
      render: (value) => {
        if (!value) return "-";

        const shift = value.trim().toLowerCase();

        let badgeClass = "badge-secondary"; // default
        switch (shift) {
          case "general":
            badgeClass = "badge-success";
            break;
          case "morning":
            badgeClass = "badge-info";
            break;
          case "afternoon":
            badgeClass = "badge-secondary";
            break;
          case "nightshift":
            badgeClass = "badge-primary";
            break;
        }

        return <span className={`badge ${badgeClass} badge-xs`}>{value}</span>;
      },
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text) => {
        const status = text?.toLowerCase();

        let badgeClass = "badge-secondary"; // default
        switch (status) {
          case "present":
            badgeClass = "badge-success";
            break;
          case "late":
            badgeClass = "badge-warning";
            break;
          case "leave":
          case "absent":
            badgeClass = "badge-danger";
            break;
          case "holiday":
            badgeClass = "badge-primary";
            break;
          case "weekoff":
            badgeClass = "badge-secondary";
            break;
          case "No Swipe":
            badgeClass = "badge-danger";
            break;
        }

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        );
      },
      sorter: (a, b) => a.Status?.length - b.Status?.length,
    },
    {
      title: "Clock In",
      dataIndex: "InTime",
      sorter: (a, b) => a.InTime?.length - b.InTime?.length,
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
      },
    },
    {
      title: "Clock Out",
      dataIndex: "OutTime",
      sorter: (a, b) => a.OutTime?.length - b.OutTime?.length,
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
      },
    },
    {
      title: "Duration",
      dataIndex: "Duration",
      sorter: (a, b) => a.Duration?.length - b.Duration?.length,
      render: (value) => value || "-",
    },
  ];

  return (
    <div>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="attendance-header">
            <div className="attendance-content">
              <ImageWithBasePath
                src="./assets/img/icons/hand01.svg"
                className="hand-img"
                alt="img"
              />
              <h3>
                {greeting}, <span>{userData?.UserName}</span>
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-12 d-flex">
              <div className="card w-100 border-0">
                <div className="card-body">
                  <h5 className="mb-3 pb-3 border-bottom d-flex justify-content-between align-items-center fs-18">
                    <i className="fa-solid fa-user-clock"></i>Attendance
                    <span className="text-purple fs-14">{formattedDate}</span>
                  </h5>
                  <div className="d-flex align-items-center mb-3">
                    <div className="me-2">
                      <ImageWithBasePath
                        src="./assets/img/icons/time-big.svg"
                        alt="time-img"
                      />
                    </div>
                    <div>
                      <h2>{time}</h2>
                      <p>Current Time</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <Link
                      to="#"
                      className={`w-100 me-2 ${
                        punchType === "In"
                          ? "btn btn-primary"
                          : "btn btn-secondary"
                      }`}
                      disabled={punchLoading}
                      onClick={handlePunch}
                    >
                      {punchLoading
                        ? "Loading..."
                        : punchType === "In"
                          ? "Clock In"
                          : "Clock Out"}
                    </Link>
                    {/* <Link to="#" className="btn btn-secondary me-2 w-100">
                      Break
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-9 col-lg-12 d-flex">
              <div className="card w-100 border-0">
                <div className="card-header px-1">
                  <div className="row my-1">
                    <div className="col-3 border-end">
                      <h5 className="ms-2">
                        <i className="fa-solid fa-circle-info me-2"></i>Details
                      </h5>
                    </div>
                    <div className="col-9 ">
                      <h5>
                        <i className="fa-solid fa-chart-column me-2"></i>
                        Overview This Month
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-3 border-end rounded">
                      <div className="p-2 ">
                        <div className="mb-2 d-flex align-items-center">
                          {/* <i className="fa-solid fa-id-card-clip me-2 fa-lg text-info"></i> */}
                          <img
                            src={designation}
                            style={{ width: "20px" }}
                            className="me-2"
                          />
                          <h6 className="text-gray">
                            {profileData[0]?.Designation || "N/A"}
                          </h6>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          {/* <i className="fa-solid fa-id-badge me-3 fa-lg text-info"></i> */}
                          <img
                            src={badge}
                            style={{ width: "20px" }}
                            className="me-2"
                          />
                          <h6 className="text-gray">
                            {profileData[0]?.Badge || "N/A"}
                          </h6>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          {/* <i className="fa-solid fa-envelope me-2 fa-lg text-info"></i> */}
                          <img
                            src={email}
                            style={{ width: "20px" }}
                            className="me-2"
                          />
                          <Tooltip title={profileData[0]?.EmailId || "N/A"}>
                            <h6 className="text-gray">
                              {profileData[0]?.EmailId
                                ? profileData[0].EmailId.length > 18
                                  ? `${profileData[0].EmailId.slice(0, 15)}...`
                                  : profileData[0].EmailId
                                : "N/A"}
                            </h6>
                          </Tooltip>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          <i className="fa-solid fa-phone me-2 fa-lg text-info"></i>
                          <h6 className="text-gray">
                            {profileData[0]?.Mobile || "N/A"}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-9">
                      <div className="row gy-3 d-flex justify-content-between">
                        <div className="col-lg-2 col-md-3 col-sm-4 text-center">
                          <div>
                            <span className="d-flex align-items-center justify-content-center avatar avatar-xl bg-primary-transparent fw-bold fs-20 mb-2 mx-auto">
                              0
                            </span>
                            <p className="fs-14">
                              Total Leaves <br />
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-4 text-center">
                          <div>
                            <span className="d-flex align-items-center justify-content-center avatar avatar-xl bg-danger-transparent fw-bold fs-20 mb-2 mx-auto">
                              0
                            </span>
                            <p className="fs-14">
                              Available
                              <br />
                              Leaves
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-4 text-center">
                          <div>
                            <span className="d-flex align-items-center justify-content-center avatar avatar-xl bg-purple-transparent text-purple fw-bold fs-20 mb-2 mx-auto">
                              0
                            </span>
                            <p className="fs-14">
                              Used <br />
                              Leaves
                            </p>
                          </div>
                        </div>
                        {/* <div className="col-lg-2 col-md-3 col-sm-4 text-center ">
                          <div>
                            <span className="d-flex align-items-center justify-content-center avatar avatar-xl bg-warning-transparent fw-bold fs-20 mb-2 mx-auto">
                              0
                            </span>
                            <p className="fs-14">
                              Carry
                              <br /> Forward
                            </p>
                          </div>
                        </div> */}
                        <Link
                          to=""
                          className="col-lg-2 col-md-3 col-sm-4 text-center"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasRightHolidays"
                          aria-controls="offcanvasRightHolidays"
                        >
                          <div>
                            <span className="d-flex align-items-center justify-content-center avatar avatar-xl bg-cyan-transparent text-cyan fw-bold fs-20 mb-2 mx-auto">
                              {monthlyHolidayCount}
                            </span>
                            <p className="fs-14">
                              Holidays
                              <br />
                              this month
                            </p>
                          </div>
                        </Link>
                        <Link
                          to=""
                          className="col-lg-2 col-md-3 col-sm-4 text-center"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasRightHolidays"
                          aria-controls="offcanvasRightHolidays"
                        >
                          <div>
                            <span className="d-flex align-items-center justify-content-center avatar avatar-xl bg-success-transparent text-success fw-bold mb-2 mx-auto">
                              <h5 className="text-success">
                                {nextHoliday?.date}
                              </h5>
                            </span>
                            <p className="fs-14">
                              Next <br /> Holiday
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="row">
            <div className="col-12 d-flex">
              <div className="card table-list-card  no-search flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>
                    <i className="fa-solid fa-calendar-days me-2"></i>
                    Last 15 days Attendance
                  </h5>
                  <div className="search-set"></div>
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <Link to="/rollcall/attendance">
                      <button className="btn btn-secondary btn-sm">
                        <i className="fa-solid fa-list-ul me-2"></i>Show all
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="card-body pb-0">
                  <div className="table-responsive">
                    {loading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p>Loading data...</p>
                      </div>
                    ) : attendance.length > 0 ? (
                      <Table columns={columns} dataSource={attendance} />
                    ) : (
                      <p className="text-center my-4">No data available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
      <Holidays holidayObj={holidays} />
    </div>
  );
};

export default RollcallDashboard;
